import { useForBinding } from '@practium/features/forBinding';
import { usePermissions } from '@practium/features/permissions';
import { MaintenanceAdvicePage } from '@practium/features/recommendations';
import { LoadingState } from '@practium/ui';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { getRecommendationsListPath } from '../routes';
import {
	useDeleteAdviceMaintenance,
	useGetAdviceMaintenanceById,
} from '@practium/features/api';

export const EditMaintenanceAdvicePageClient = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const id = searchParams.get('id') || '';
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();
	const subject = isForBinding ? 'farmers-recommendations' : 'recommendations';
	const { data: advice, isLoading } = useGetAdviceMaintenanceById(id);
	const { mutateAsync: deleteMaintenanceAdvice } = useDeleteAdviceMaintenance();

	const canEdit = abilities.can('update', subject);

	const canDelete = abilities.can('delete', subject);

	if (!canEdit) return <Navigate to="/recomendacoes" replace />;
	if (!advice || isLoading) return <LoadingState />;

	const handleDelete = async () => {
		await deleteMaintenanceAdvice(id);
		navigate(getRecommendationsListPath('maintenance'));
	};

	return (
		<MaintenanceAdvicePage
			initialMode="edit"
			viewData={advice}
			adviceId={id}
			onBack={() => navigate(getRecommendationsListPath('maintenance'))}
			onDelete={canDelete ? handleDelete : undefined}
		/>
	);
};
